import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FuseMasonryModule } from '@fuse/components/masonry';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslocoModule } from '@ngneat/transloco';
import { SharedModule } from 'app/shared/shared.module';
import { FiltersComponent } from './filters.component';

@NgModule({
  declarations: [
    FiltersComponent
  ],
  imports: [
    RouterModule.forChild([]),
    MatGridListModule,
    MatDividerModule,
    // MatAutocompleteModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
    NgSelectModule,
    MatProgressBarModule,
    FuseMasonryModule,
    SharedModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTooltipModule,
    TranslocoModule,
    MatExpansionModule
  ],
  exports: [
    FiltersComponent
  ],
  providers: [
    // Set format for matdatepicker
    { provide: MAT_DATE_LOCALE, useValue: 'el' }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FiltersModule {}